import { Injectable } from '@angular/core';
import { gql, Query } from 'apollo-angular';

import { Query as RootQuery } from 'graphql/models/generated';

export const POSITION_CUSTOM_PROPERTIES_QUERY = gql`
  query quoteWithLinesCustomProps($documentVersion: DocumentVersionInput!) {
    quotes {
      quote(documentVersion: $documentVersion) {
        lines {
          isSubLine
          customProperties {
            stringValue
            key
          }
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class PositionCustomPropertiesQuery extends Query<RootQuery> {
  document = POSITION_CUSTOM_PROPERTIES_QUERY;
}
